<template>
  <layout-header />
  <layout-sidebar />

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-4"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="head-icons ms-2">
          <a
            href="javascript:void(0);"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-original-title="Collapse"
            id="collapse-header"
            @click="toggleHeader"
          >
            <i class="ti ti-chevrons-up"></i>
          </a>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <settings-tab />

      <div class="row">
        <general-sidebar />

        <div class="col-xl-9">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <!-- Enhanced Header with Icon -->
              <div class="d-flex align-items-center mb-4 pb-3 border-bottom">
                <div
                  class="avatar avatar-lg bg-primary-transparent rounded me-3"
                >
                  <i class="ti ti-user-cog fs-24 text-primary"></i>
                </div>
                <div>
                  <h4 class="mb-1 fw-semibold">Profile Settings</h4>
                  <p class="text-muted mb-0 small">
                    Manage your company and admin profile information
                  </p>
                </div>
              </div>

              <!-- Enhanced TABS with Icons -->
              <div class="contact-grids-tab mb-4">
                <ul
                  class="nav nav-pills nav-justified gap-2"
                  id="profileTab"
                  role="tablist"
                >
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active d-flex align-items-center justify-content-center gap-2 py-3"
                      id="basic-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      <i class="ti ti-info-circle"></i>
                      <span>Basic Info</span>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link d-flex align-items-center justify-content-center gap-2 py-3"
                      id="address-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#address"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      <i class="ti ti-map-pin"></i>
                      <span>Address</span>
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link d-flex align-items-center justify-content-center gap-2 py-3"
                      id="social-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#social-profile"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      <i class="ti ti-share"></i>
                      <span>Social Links</span>
                    </button>
                  </li>
                </ul>
              </div>

              <form @submit.prevent="submitForm" novalidate>
                <div class="tab-content" id="profileTabContent">
                  <!-- BASIC INFO TAB -->
                  <div
                    class="tab-pane fade show active"
                    id="basic-info"
                    role="tabpanel"
                    aria-labelledby="basic-tab"
                    tabindex="0"
                  >
                    <!-- Enhanced Company Logo Section -->
                    <div class="mb-4">
                      <div class="card bg-light border-0">
                        <div class="card-body p-4">
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <div
                                class="position-relative"
                                style="width: 100px; height: 100px"
                              >
                                <div
                                  class="avatar avatar-xxl rounded-circle border border-3 border-white shadow-sm overflow-hidden"
                                  style="width: 100px; height: 100px"
                                >
                                  <img
                                    v-if="companyForm.imageUrl"
                                    :src="companyForm.imageUrl"
                                    class="w-100 h-100 object-fit-cover"
                                    alt="Company Logo"
                                  />
                                  <div
                                    v-else
                                    class="w-100 h-100 d-flex align-items-center justify-content-center bg-white"
                                  >
                                    <i
                                      class="ti ti-building fs-1 text-muted"
                                    ></i>
                                  </div>
                                </div>
                                <div
                                  class="position-absolute bottom-0 end-0 bg-primary rounded-circle p-2 border border-3 border-white"
                                  style="cursor: pointer"
                                >
                                  <i class="ti ti-camera text-white fs-16"></i>
                                </div>
                              </div>
                            </div>
                            <div class="col">
                              <h6 class="mb-2 fw-semibold">Company Logo</h6>
                              <p class="text-muted small mb-3">
                                Upload your company logo. Maximum size: 4MB
                              </p>
                              <div class="d-flex align-items-center gap-2">
                                <div
                                  class="drag-upload-btn btn btn-primary btn-sm"
                                >
                                  <i class="ti ti-upload me-1"></i>
                                  Upload Logo
                                  <input
                                    type="file"
                                    class="form-control image-sign"
                                    accept="image/*"
                                    @change="onLogoChange"
                                  />
                                </div>
                                <button
                                  v-if="companyForm.imageUrl"
                                  type="button"
                                  class="btn btn-outline-danger btn-sm"
                                  @click="removeLogo"
                                >
                                  <i class="ti ti-trash me-1"></i>
                                  Remove
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Admin Profile Section -->
                    <div class="mb-4">
                      <div class="d-flex align-items-center mb-3">
                        <div
                          class="avatar avatar-sm bg-info-transparent rounded me-2"
                        >
                          <i class="ti ti-user fs-16 text-info"></i>
                        </div>
                        <h5 class="mb-0 fw-semibold">Administrator Profile</h5>
                      </div>

                      <div class="card border">
                        <div class="card-body p-4">
                          <div class="row g-3">
                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                First Name <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-user text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="userForm.first_name"
                                  placeholder="Enter first name"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Middle Name</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-user text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="userForm.middle_name"
                                  placeholder="Enter middle name (optional)"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Last Name <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-user text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="userForm.last_name"
                                  placeholder="Enter last name"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Email <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-mail text-muted"></i>
                                </span>
                                <input
                                  type="email"
                                  class="form-control border-start-0"
                                  v-model="userForm.email"
                                  placeholder="admin@example.com"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Phone <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-phone text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="userForm.phone"
                                  placeholder="+254 700 000000"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">Gender</label>
                              <vue-select
                                :options="['Male', 'Female', 'Other']"
                                placeholder="Select gender"
                                v-model="userForm.gender"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Company Profile Section -->
                    <div class="mb-4">
                      <div class="d-flex align-items-center mb-3">
                        <div
                          class="avatar avatar-sm bg-success-transparent rounded me-2"
                        >
                          <i class="ti ti-building fs-16 text-success"></i>
                        </div>
                        <h5 class="mb-0 fw-semibold">Company Information</h5>
                      </div>

                      <div class="card border">
                        <div class="card-body p-4">
                          <div class="row g-3">
                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Company Name <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-building text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.company_name"
                                  placeholder="Enter registered company name"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Company Email <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-mail text-muted"></i>
                                </span>
                                <input
                                  type="email"
                                  class="form-control border-start-0"
                                  v-model="companyForm.email"
                                  placeholder="info@company.com"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Company PIN <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-id text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.kra_pin"
                                  placeholder="Enter tax / KRA PIN"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Company Phone <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-phone text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.phone"
                                  placeholder="+254 700 000000"
                                  required
                                />
                              </div>
                            </div>


                              <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Company NSSF <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-id text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.nssf"
                                  placeholder="Enter NSSF number"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Company NHIF/SHIF/SHA <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-id text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.shif"
                                  placeholder="Enter NHIF/SHIF/SHA number"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Phone Number 2</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-phone text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.phone_two"
                                  placeholder="Secondary contact (optional)"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">Fax</label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-printer text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.fax"
                                  placeholder="Fax number (optional)"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Currency</label
                              >
                              <vue-select
                                :options="DolarSel"
                                id="dolarsel"
                                placeholder="Select currency"
                                v-model="companyForm.currency"
                              />
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Currency Code <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i
                                    class="ti ti-currency-dollar text-muted"
                                  ></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.currency_code"
                                  placeholder="e.g. KES, USD, EUR"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Timezone <span class="text-danger">*</span>
                              </label>
                              <vue-select
                                :options="timezones"
                                placeholder="Select timezone"
                                v-model="companyForm.timezone"
                                :clearable="false"
                              />
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Website</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-world text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.website_url"
                                  placeholder="https://www.company.com"
                                />
                              </div>
                            </div>

                            <div class="col-md-12">
                              <label class="form-label fw-medium"
                                >About Company</label
                              >
                              <textarea
                                class="form-control"
                                v-model="companyForm.about"
                                placeholder="Brief description of your company (industry, services, etc.)"
                                rows="4"
                              ></textarea>
                            </div>
                          </div>

                          <!-- BANK DETAILS SECTION -->
                          <div class="mt-4 pt-3 border-top">
                            <div class="d-flex align-items-center mb-3">
                              <div
                                class="avatar avatar-sm bg-warning-transparent rounded me-2"
                              >
                                <i
                                  class="ti ti-building-bank fs-16 text-warning"
                                ></i>
                              </div>
                              <h5 class="mb-0 fw-semibold">Bank Details</h5>
                            </div>

                            <div class="row g-3">
                              <!-- Bank Name (dropdown) -->
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Bank Name <span class="text-danger">*</span>
                                </label>

                                <div class="dropdown w-100">
                                  <button
                                    class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                  >
                                    <span class="text-truncate">
                                      {{
                                        companyForm.bank_name || "Select bank"
                                      }}
                                    </span>
                                    <i class="ti ti-chevron-down ms-2"></i>
                                  </button>

                                  <div class="dropdown-menu p-2 w-100 shadow">
                                    <input
                                      v-model="bankQuery"
                                      type="text"
                                      class="form-control mb-2"
                                      placeholder="Search bank..."
                                      autocomplete="off"
                                    />
                                    <div
                                      class="search-list"
                                      style="
                                        max-height: 240px;
                                        overflow-y: auto;
                                      "
                                    >
                                      <button
                                        v-for="b in filteredBanks"
                                        :key="b.bank_name"
                                        type="button"
                                        class="dropdown-item text-truncate"
                                        @click="chooseBank(b)"
                                      >
                                        {{ b.bank_name }}
                                      </button>
                                      <div
                                        v-if="filteredBanks.length === 0"
                                        class="text-center py-2 small text-muted"
                                      >
                                        No bank found
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Bank Code (readonly) -->
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Bank Code <span class="text-danger">*</span>
                                </label>
                                <input
                                  v-model="companyForm.bank_code"
                                  type="text"
                                  class="form-control"
                                  readonly
                                />
                              </div>

                              <!-- Account No -->
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Bank Account No
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  v-model="companyForm.account_number"
                                  type="text"
                                  class="form-control"
                                />
                              </div>

                              <!-- Account Holder -->
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Bank Account Holder Name
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  v-model="companyForm.account_holder_name"
                                  type="text"
                                  class="form-control"
                                />
                              </div>

                              <!-- Branch (dropdown) -->
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Bank Branch <span class="text-danger">*</span>
                                </label>

                                <div class="dropdown w-100">
                                  <button
                                    class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                                    type="button"
                                    :disabled="!companyForm.bank_name"
                                    data-bs-toggle="dropdown"
                                  >
                                    <span class="text-truncate">
                                      {{
                                        companyForm.branch_location ||
                                        (companyForm.bank_name
                                          ? "Select branch"
                                          : "Select bank first")
                                      }}
                                    </span>
                                    <i class="ti ti-chevron-down ms-2"></i>
                                  </button>

                                  <div
                                    v-if="companyForm.bank_name"
                                    class="dropdown-menu p-2 w-100 shadow"
                                  >
                                    <input
                                      v-model="branchQuery"
                                      type="text"
                                      class="form-control mb-2"
                                      placeholder="Search branch..."
                                      autocomplete="off"
                                    />
                                    <div
                                      class="search-list"
                                      style="
                                        max-height: 240px;
                                        overflow-y: auto;
                                      "
                                    >
                                      <button
                                        v-for="b in filteredBranches"
                                        :key="b.bank_name + '-' + b.branch_code"
                                        type="button"
                                        class="dropdown-item text-truncate"
                                        @click="chooseBranch(b)"
                                      >
                                        {{ b.branch_name }} ({{
                                          b.branch_code
                                        }})
                                      </button>
                                      <div
                                        v-if="filteredBranches.length === 0"
                                        class="text-center py-2 small text-muted"
                                      >
                                        No branch found
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Branch Code (readonly) -->
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Branch Code <span class="text-danger">*</span>
                                </label>
                                <input
                                  v-model="companyForm.branch_code"
                                  type="text"
                                  class="form-control"
                                  readonly
                                />
                              </div>
                            </div>
                          </div>
                          <!-- /BANK DETAILS SECTION -->

                          <div class="mt-4 pt-3 border-top">
                            <div class="d-flex align-items-center mb-3">
                              <div
                                class="avatar avatar-sm bg-info-transparent rounded me-2"
                              >
                                <i
                                  class="ti ti-signature fs-16 text-info"
                                ></i>
                              </div>
                              <h5 class="mb-0 fw-semibold">Invoice Signatory</h5>
                            </div>

                            <div class="row g-3">
                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Signatory Name
                                </label>
                                <input
                                  v-model="companyForm.signatory_name"
                                  type="text"
                                  class="form-control"
                                  placeholder="Authorized signatory name"
                                />
                              </div>

                              <div class="col-md-6">
                                <label class="form-label fw-medium">
                                  Signatory Title
                                </label>
                                <input
                                  v-model="companyForm.signatory_title"
                                  type="text"
                                  class="form-control"
                                  placeholder="Finance Manager"
                                />
                              </div>

                              <div class="col-md-12">
                                <label class="form-label fw-medium">
                                  Signature Image
                                </label>
                                <div class="border rounded p-3 bg-light">
                                  <div
                                    class="d-flex flex-column flex-md-row align-items-md-center gap-3"
                                  >
                                    <div class="flex-shrink-0">
                                      <div
                                        v-if="companyForm.signatorySignatureUrl"
                                        class="bg-white border rounded p-2"
                                      >
                                        <img
                                          :src="companyForm.signatorySignatureUrl"
                                          alt="Signatory Signature"
                                          style="max-height: 72px; max-width: 220px"
                                        />
                                      </div>
                                      <div
                                        v-else
                                        class="border rounded bg-white px-4 py-3 text-muted small"
                                      >
                                        No signature uploaded
                                      </div>
                                    </div>
                                    <div class="flex-grow-1">
                                      <input
                                        type="file"
                                        class="form-control"
                                        accept="image/*"
                                        @change="onSignatorySignatureChange"
                                      />
                                      <div class="form-text">
                                        Used on invoice previews and exported documents when available.
                                      </div>
                                    </div>
                                    <div
                                      v-if="companyForm.signatorySignatureUrl"
                                      class="flex-shrink-0"
                                    >
                                      <button
                                        type="button"
                                        class="btn btn-light"
                                        @click="removeSignatorySignature"
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-12">
                                <div class="dq-signatory-preview card border mb-0">
                                  <div class="card-body">
                                    <div class="d-flex align-items-center justify-content-between mb-3">
                                      <div>
                                        <h6 class="mb-1 fw-semibold">Invoice Preview</h6>
                                        <p class="mb-0 text-muted small">
                                          This mirrors the signature and payment footer shown on invoice previews.
                                        </p>
                                      </div>
                                      <span class="badge bg-light text-dark border">Live Preview</span>
                                    </div>

                                    <div class="dq-signatory-preview-sheet">
                                      <div class="d-flex justify-content-between align-items-start gap-3 flex-wrap">
                                        <div class="d-flex align-items-center gap-3">
                                          <template v-if="companyForm.imageUrl">
                                            <img
                                              :src="companyForm.imageUrl"
                                              alt="Company Logo"
                                              class="dq-signatory-logo"
                                            />
                                          </template>
                                          <template v-else>
                                            <div class="dq-signatory-logo-fallback">
                                              {{
                                                (companyForm.company_name || "CN")
                                                  .split(" ")
                                                  .filter(Boolean)
                                                  .map((part) => part[0])
                                                  .join("")
                                                  .slice(0, 2)
                                                  .toUpperCase()
                                              }}
                                            </div>
                                          </template>
                                          <div>
                                            <div class="fw-semibold">
                                              {{ companyForm.company_name || "Company Name" }}
                                            </div>
                                            <div class="text-muted small">
                                              {{ companyForm.address || "Company address" }}
                                            </div>
                                          </div>
                                        </div>
                                        <div class="text-end dq-signatory-signblock">
                                          <template v-if="companyForm.signatorySignatureUrl">
                                            <img
                                              :src="companyForm.signatorySignatureUrl"
                                              alt="Signature Preview"
                                              class="dq-signatory-image"
                                            />
                                          </template>
                                          <div v-else class="dq-signatory-line"></div>
                                          <div class="fw-semibold mt-2">
                                            {{ companyForm.signatory_name || "Authorized Signatory" }}
                                          </div>
                                          <div class="text-muted small">
                                            {{ companyForm.signatory_title || "Finance Manager" }}
                                          </div>
                                        </div>
                                      </div>

                                      <div class="dq-signatory-footer mt-3 pt-3">
                                        <div class="small text-muted mb-2">
                                          Payment may be made via bank transfer or cheque in the name of
                                          <span class="text-dark fw-medium">
                                            {{
                                              companyForm.account_holder_name ||
                                              companyForm.company_name ||
                                              "Company Name"
                                            }}
                                          </span>.
                                        </div>
                                        <div class="d-flex flex-wrap gap-3 small">
                                          <span>
                                            Bank:
                                            <strong>{{ companyForm.bank_name || "Bank name" }}</strong>
                                          </span>
                                          <span>
                                            Account:
                                            <strong>{{ companyForm.account_number || "—" }}</strong>
                                          </span>
                                          <span v-if="companyForm.branch_location">
                                            Branch:
                                            <strong>{{ companyForm.branch_location }}</strong>
                                          </span>
                                          <span v-if="companyForm.branch_code">
                                            Branch Code:
                                            <strong>{{ companyForm.branch_code }}</strong>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- ADDRESS TAB -->
                  <div
                    class="tab-pane fade"
                    id="address"
                    role="tabpanel"
                    aria-labelledby="address-tab"
                    tabindex="0"
                  >
                    <div class="mb-4">
                      <div class="d-flex align-items-center mb-3">
                        <div
                          class="avatar avatar-sm bg-warning-transparent rounded me-2"
                        >
                          <i class="ti ti-map-pin fs-16 text-warning"></i>
                        </div>
                        <h5 class="mb-0 fw-semibold">Address Details</h5>
                      </div>

                      <div class="card border">
                        <div class="card-body p-4">
                          <div class="row g-3">
                            <div class="col-md-12">
                              <label class="form-label fw-medium">
                                Street Address
                                <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-home text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.address"
                                  placeholder="Head office street address"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >State / Region</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-map text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.state"
                                  placeholder="State, county or region"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Country <span class="text-danger">*</span>
                              </label>
                              <div class="dropdown w-100">
                                <button
                                  class="btn btn-outline-secondary w-100 d-flex justify-content-between align-items-center"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                >
                                  <span class="text-truncate">
                                    <i class="ti ti-world me-2 text-muted"></i>
                                    {{
                                      companyForm.country || "Select country"
                                    }}
                                  </span>
                                  <i class="ti ti-chevron-down ms-2"></i>
                                </button>

                                <div class="dropdown-menu p-2 w-100 shadow">
                                  <input
                                    v-model="countryQuery"
                                    type="text"
                                    class="form-control mb-2"
                                    placeholder="Search country..."
                                    autocomplete="off"
                                  />
                                  <div
                                    class="search-list"
                                    style="max-height: 240px; overflow-y: auto"
                                  >
                                    <button
                                      v-for="c in filteredCountries"
                                      :key="c.country"
                                      type="button"
                                      class="dropdown-item text-truncate"
                                      @click="chooseCountry(c)"
                                    >
                                      {{ c.country }}
                                    </button>
                                    <div
                                      v-if="filteredCountries.length === 0"
                                      class="text-center py-2 small text-muted"
                                    >
                                      No country found
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">
                                Country Code <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-flag text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.country_code"
                                  placeholder="e.g. KE, UG, TZ"
                                  required
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Postal / ZIP Code</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-mailbox text-muted"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.zip_code"
                                  placeholder="Postal / ZIP code"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- SOCIAL TAB -->
                  <div
                    class="tab-pane fade"
                    id="social-profile"
                    role="tabpanel"
                    aria-labelledby="social-tab"
                    tabindex="0"
                  >
                    <div class="mb-4">
                      <div class="d-flex align-items-center mb-3">
                        <div
                          class="avatar avatar-sm bg-purple-transparent rounded me-2"
                        >
                          <i class="ti ti-share fs-16 text-purple"></i>
                        </div>
                        <h5 class="mb-0 fw-semibold">Social Media Links</h5>
                      </div>

                      <div class="card border">
                        <div class="card-body p-4">
                          <div class="row g-3">
                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Facebook</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i
                                    class="ti ti-brand-facebook text-primary"
                                  ></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.facebook_profile"
                                  placeholder="Facebook page URL"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Twitter / X</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-brand-x text-dark"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.twitter_profile"
                                  placeholder="Twitter/X handle or URL"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >LinkedIn</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-brand-linkedin text-info"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.linkedin_profile"
                                  placeholder="LinkedIn company profile URL"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >Instagram</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i
                                    class="ti ti-brand-instagram text-danger"
                                  ></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.instagram_profile"
                                  placeholder="Instagram handle or URL"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium"
                                >WhatsApp</label
                              >
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i
                                    class="ti ti-brand-whatsapp text-success"
                                  ></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.whatsapp_profile"
                                  placeholder="WhatsApp business number"
                                />
                              </div>
                            </div>

                            <div class="col-md-6">
                              <label class="form-label fw-medium">Skype</label>
                              <div class="input-group">
                                <span
                                  class="input-group-text bg-light border-end-0"
                                >
                                  <i class="ti ti-brand-skype text-info"></i>
                                </span>
                                <input
                                  type="text"
                                  class="form-control border-start-0"
                                  v-model="companyForm.skype_profile"
                                  placeholder="Skype ID"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Enhanced ACTION BUTTONS -->
                <div
                  class="d-flex align-items-center justify-content-end gap-2 mt-4 pt-3 border-top"
                >
                  <button
                    type="button"
                    class="btn btn-light px-4"
                    @click="resetAll"
                    :disabled="saving"
                  >
                    <i class="ti ti-refresh me-1"></i>
                    Reset
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary px-4"
                    :disabled="saving"
                  >
                    <span
                      v-if="saving"
                      class="spinner-border spinner-border-sm me-2"
                    ></span>
                    <i v-else class="ti ti-check me-1"></i>
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useUserStore } from "@/stores/userStore";
import { useCompanyStore } from "@/stores/companyStore";
import { countries as countryList } from "@/utils/countryData";
import { toast } from "@/utils/toast";
import { banks as bankList } from "@/utils/banksData";
import {
  TIMEZONE_OPTIONS,
  COUNTRY_DEFAULT_TIMEZONE,
  normalizeTimezoneValue,
} from "@/utils/timezoneOptions";

// page labels
const title = "Settings";
const text = "Administration";
const text1 = "Settings";

const authStore = useAuthStore();
const userStore = useUserStore();
const companyStore = useCompanyStore();

const saving = ref(false);

// ----------------------- USER FORM (ADMIN) -----------------------
function defaultUserForm() {
  return {
    id: null,
    first_name: "",
    middle_name: "",
    last_name: "",
    email: "",
    phone: "",
    gender: "",
  };
}
const userForm = reactive(defaultUserForm());

const currentUser = computed(() => authStore.currentUser);

function populateUserFromStore() {
  const u = currentUser.value;
  console.log("Cuurent user now on profile", u);
  if (!u) return;
  userForm.id = u.id || null;
  userForm.first_name = u.first_name || "";
  userForm.middle_name = u.middle_name || "";
  userForm.last_name = u.last_name || "";
  userForm.email = u.email || "";
  userForm.phone = u.phone || "";
  userForm.gender = u.gender || "";
}

// ----------------------- COMPANY FORM (ACTIVE COMPANY) -----------------------
const DolarSel = [
  "Select",
  "Kenyan Shilling (KES)",
  "Ugandan Shilling (UGX)",
  "Tanzanian Shilling (TZS)",
  "Rwandan Franc (RWF)",
  "US Dollar (USD)",
  "Euro (EUR)",
  "British Pound (GBP)",
  "Japanese Yen (JPY)",
  "Chinese Yuan (CNY)",
  "Indian Rupee (INR)",
  "South African Rand (ZAR)",
  "Canadian Dollar (CAD)",
];

const CrmStat = ["Active", "Inactive"];

const timezones = TIMEZONE_OPTIONS;

// currency label -> code
const currencyCodeMap = {
  "Kenyan Shilling (KES)": "KES",
  "Ugandan Shilling (UGX)": "UGX",
  "Tanzanian Shilling (TZS)": "TZS",
  "Rwandan Franc (RWF)": "RWF",
  "US Dollar (USD)": "USD",
  "Euro (EUR)": "EUR",
  "British Pound (GBP)": "GBP",
  "Japanese Yen (JPY)": "JPY",
  "Chinese Yuan (CNY)": "CNY",
  "Indian Rupee (INR)": "INR",
  "South African Rand (ZAR)": "ZAR",
  "Canadian Dollar (CAD)": "CAD",
};

// country name -> code + default timezone
const countryCodeMap = {
  Kenya: "KE",
  Uganda: "UG",
  Tanzania: "TZ",
  Rwanda: "RW",
};
const countryTimezoneMap = COUNTRY_DEFAULT_TIMEZONE;

function defaultCompanyForm() {
  return {
    // logo
    logo: null,
    imageUrl: "",
    // basic
    company_name: "",
    email: "",
    kra_pin: "",
    nssf: "",
    shif: "",
    phone: "",
    phone_two: "",
    fax: "",
    status: "Active",
    currency: "",
    currency_code: "",
    timezone: "",
    website_url: "",
    about: "",
    // address
    address: "",
    state: "",
    country: "",
    country_code: "",
    zip_code: "",
    // socials
    facebook_profile: "",
    twitter_profile: "",
    linkedin_profile: "",
    skype_profile: "",
    whatsapp_profile: "",
    instagram_profile: "",
    // bank details
    bank_name: "",
    bank_code: "",
    account_number: "",
    account_holder_name: "",
    branch_location: "",
    branch_code: "",
    signatory_name: "",
    signatory_title: "",
    signatory_signature: null,
    signatorySignatureUrl: "",
    remove_signatory_signature: false,
  };
}
const companyForm = reactive(defaultCompanyForm());

// active company
const activeCompanyId = computed(() => companyStore.activeCompanyId);
const activeCompany = computed(() => companyStore.company);

// hydrate company form from store.company
function populateCompanyForm(c) {
  if (!c) return;

  companyForm.company_name = c.company_name || "";
  companyForm.email = c.email || "";
  companyForm.kra_pin = c.kra_pin || "";
  companyForm.nssf = c.nssf || "";
  companyForm.shif = c.shif || "";
  companyForm.phone = c.phone || "";
  companyForm.phone_two = c.phone_two || "";
  companyForm.fax = c.fax || "";
  companyForm.status = c.status || "Active";
  companyForm.currency = c.currency || "";
  companyForm.currency_code = c.currency_code || "";
  companyForm.timezone = normalizeTimezoneValue(c.timezone);
  companyForm.website_url = c.website_url || "";
  companyForm.about = c.about || "";

  companyForm.address = c.address || "";
  companyForm.state = c.state || "";
  companyForm.country = c.country || "";
  companyForm.country_code = c.country_code || "";
  companyForm.zip_code = c.zip_code || "";

  companyForm.facebook_profile = c.facebook_profile || "";
  companyForm.twitter_profile = c.twitter_profile || "";
  companyForm.linkedin_profile = c.linkedin_profile || "";
  companyForm.skype_profile = c.skype_profile || "";
  companyForm.whatsapp_profile = c.whatsapp_profile || "";
  companyForm.instagram_profile = c.instagram_profile || "";

  companyForm.imageUrl = c.logo_url || "";

  // bank details
  companyForm.bank_name = c.bank_name || "";
  companyForm.bank_code = c.bank_code || "";
  companyForm.account_number = c.account_number || "";
  companyForm.account_holder_name = c.account_holder_name || "";
  companyForm.branch_location = c.branch_location || "";
  companyForm.branch_code = c.branch_code || "";
  companyForm.signatory_name = c.signatory_name || "";
  companyForm.signatory_title = c.signatory_title || "";
  companyForm.signatorySignatureUrl = c.signatory_signature_url || "";
  companyForm.signatory_signature = null;
  companyForm.remove_signatory_signature = false;
}

// watch for activeCompany payload
watch(
  () => activeCompany.value,
  (c) => {
    if (c) populateCompanyForm(c);
  },
  { deep: true }
);

// auto currency_code
watch(
  () => companyForm.currency,
  (val) => {
    if (!val) {
      companyForm.currency_code = "";
      return;
    }
    const code = currencyCodeMap[val];
    if (code) companyForm.currency_code = code;
  }
);

// auto country_code + default timezone
watch(
  () => companyForm.country,
  (val) => {
    if (!val) {
      companyForm.country_code = "";
      return;
    }
    const code = countryCodeMap[val];
    if (code) {
      companyForm.country_code = code;
      if (!companyForm.timezone) {
        const tz = countryTimezoneMap[code];
        if (tz) companyForm.timezone = tz;
      }
    }
  }
);

// ----------------------- COUNTRY DROPDOWN -----------------------
const countryQuery = ref("");

const filteredCountries = computed(() => {
  const q = countryQuery.value.trim().toLowerCase();
  if (!q) return countryList;
  return countryList.filter((c) => c.country.toLowerCase().includes(q));
});

function chooseCountry(c) {
  companyForm.country = c.country;
  countryQuery.value = "";

  const code = countryCodeMap[c.country];
  if (code) {
    companyForm.country_code = code;
    if (!companyForm.timezone) {
      const tz = countryTimezoneMap[code];
      if (tz) companyForm.timezone = tz;
    }
  }
}

// ---------- BANK / BRANCH DROPDOWNS ----------

// search queries
const bankQuery = ref("");
const branchQuery = ref("");

// unique bank list: { bank_name, bank_code }
const uniqueBanks = computed(() => {
  const map = new Map();
  bankList.forEach((b) => {
    if (!map.has(b.bank_name)) {
      map.set(b.bank_name, b.bank_code);
    }
  });
  return Array.from(map, ([bank_name, bank_code]) => ({
    bank_name,
    bank_code,
  }));
});

// bank filter
const filteredBanks = computed(() => {
  const q = bankQuery.value.trim().toLowerCase();
  if (!q) return uniqueBanks.value;
  return uniqueBanks.value.filter((b) => b.bank_name.toLowerCase().includes(q));
});

// branches available for selected bank
const availableBranches = computed(() => {
  if (!companyForm.bank_name) return [];
  return bankList.filter((b) => b.bank_name === companyForm.bank_name);
});

// branch filter
const filteredBranches = computed(() => {
  const q = branchQuery.value.trim().toLowerCase();
  let list = availableBranches.value;
  if (!q) return list;

  return list.filter(
    (b) =>
      b.branch_name.toLowerCase().includes(q) ||
      String(b.branch_code).toLowerCase().includes(q)
  );
});

// choose bank: set bank name + code and reset branch fields
function chooseBank(bank) {
  companyForm.bank_name = bank.bank_name;
  companyForm.bank_code = bank.bank_code || "";

  // reset branch stuff when bank changes
  companyForm.branch_location = "";
  companyForm.branch_code = "";
  branchQuery.value = "";
}

// choose branch: set branch name + code
function chooseBranch(branch) {
  companyForm.branch_location = branch.branch_name;
  companyForm.branch_code = branch.branch_code || "";
}

// ----------------------- LOGO UPLOAD -----------------------
function onLogoChange(e) {
  const file = e.target.files?.[0];
  if (!file) {
    companyForm.logo = null;
    companyForm.imageUrl = "";
    return;
  }
  if (!file.type?.startsWith("image/")) {
    toast("Please select a valid image file", "error");
    companyForm.logo = null;
    companyForm.imageUrl = "";
    return;
  }
  companyForm.logo = file;
  const reader = new FileReader();
  reader.onload = (evt) => (companyForm.imageUrl = evt.target.result);
  reader.readAsDataURL(file);
}

function removeLogo() {
  companyForm.logo = null;
  companyForm.imageUrl = "";
}

function onSignatorySignatureChange(e) {
  const file = e.target.files?.[0];
  if (!file) {
    companyForm.signatory_signature = null;
    companyForm.signatorySignatureUrl = "";
    return;
  }
  if (!file.type?.startsWith("image/")) {
    toast("Please select a valid signature image", "error");
    companyForm.signatory_signature = null;
    companyForm.signatorySignatureUrl = "";
    return;
  }
  companyForm.signatory_signature = file;
  companyForm.remove_signatory_signature = false;
  const reader = new FileReader();
  reader.onload = (evt) => (companyForm.signatorySignatureUrl = evt.target.result);
  reader.readAsDataURL(file);
}

function removeSignatorySignature() {
  companyForm.signatory_signature = null;
  companyForm.signatorySignatureUrl = "";
  companyForm.remove_signatory_signature = true;
}

// ----------------------- HEADER TOGGLE -----------------------
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// ----------------------- RESET -----------------------
function resetAll() {
  // restore from stores, not blank
  Object.assign(userForm, defaultUserForm());
  Object.assign(companyForm, defaultCompanyForm());
  populateUserFromStore();
  populateCompanyForm(activeCompany.value);
}

// ----------------------- SUBMIT (USER + COMPANY) -----------------------
// function validateBasic() {
//   if (
//     !userForm.first_name ||
//     !userForm.last_name ||
//     !userForm.email ||
//     !userForm.phone
//   ) {
//     return "First name, last name, email and phone are required for the admin user.";
//   }

//   if (!companyForm.company_name) return "Company name is required.";
//   if (!companyForm.email) return "Company email is required.";
//   if (!companyForm.kra_pin) return "Company PIN is required.";
//   if (!companyForm.phone) return "Company phone is required.";
//   if (!companyForm.currency_code) return "Currency code is required.";
//   if (!companyForm.timezone) return "Timezone is required.";
//   return null;
// }

// function validateAddress() {
//   if (!companyForm.address) return "Company address is required.";
//   if (!companyForm.country) return "Country is required.";
//   if (!companyForm.country_code) return "Country code is required.";
//   return null;
// }

async function submitForm() {
  if (!currentUser.value || !currentUser.value.id) {
    toast("Unable to determine current user.", "error");
    return;
  }
  if (!activeCompanyId.value) {
    toast("No active company selected.", "error");
    return;
  }

  // const basicError = validateBasic();
  // const addrError = validateAddress();
  // if (basicError || addrError) {
  //   if (basicError) {
  //     document.getElementById("basic-tab")?.click();
  //     toast(basicError, "error");
  //   } else if (addrError) {
  //     document.getElementById("address-tab")?.click();
  //     toast(addrError, "error");
  //   }
  //   return;
  // }

  saving.value = true;

  try {
    // ---- 1) Update USER (admin) ----
    const userPayload = {
      id: userForm.id,
      first_name: userForm.first_name,
      middle_name: userForm.middle_name,
      last_name: userForm.last_name,
      email: userForm.email,
      phone: userForm.phone,
      gender: userForm.gender,
      fromUser: null,
    };

    await userStore.updateUser(userPayload);

    // Keep company email/phone in sync with admin by default
    if (!companyForm.email) companyForm.email = userForm.email;
    if (!companyForm.phone) companyForm.phone = userForm.phone;

    // ---- 2) Update COMPANY (active company) ----
    const fd = new FormData();

    if (companyForm.logo instanceof File) {
      fd.append("logo", companyForm.logo, companyForm.logo.name);
    }
    if (companyForm.signatory_signature instanceof File) {
      fd.append(
        "signatory_signature",
        companyForm.signatory_signature,
        companyForm.signatory_signature.name
      );
    }
    if (companyForm.remove_signatory_signature) {
      fd.append("remove_signatory_signature", "1");
    }

    const fieldMappings = {
      company_name: "company_name",
      email: "email",
      kra_pin: "kra_pin",
      nssf: "nssf",
      shif: "shif",
      phone: "phone",
      phone_two: "phone_two",
      fax: "fax",
      status: "status",
      currency: "currency",
      currency_code: "currency_code",
      timezone: "timezone",
      website_url: "website_url",
      about: "about",
      address: "address",
      state: "state",
      country: "country",
      country_code: "country_code",
      zip_code: "zip_code",
      facebook_profile: "facebook_profile",
      twitter_profile: "twitter_profile",
      linkedin_profile: "linkedin_profile",
      skype_profile: "skype_profile",
      whatsapp_profile: "whatsapp_profile",
      instagram_profile: "instagram_profile",
      bank_name: "bank_name",
      bank_code: "bank_code",
      account_number: "account_number",
      account_holder_name: "account_holder_name",
      branch_location: "branch_location",
      branch_code: "branch_code",
      signatory_name: "signatory_name",
      signatory_title: "signatory_title",
    };

    Object.entries(fieldMappings).forEach(([formKey, fdKey]) => {
      const val = companyForm[formKey];
      if (val !== null && val !== undefined && val !== "") {
        fd.append(fdKey, val);
      }
    });

    fd.append("_method", "PUT");

    // 🔹 Pass `true` to make this update silent (no company toast)
    await companyStore.updateCompany(activeCompanyId.value, fd, true);

    // refresh user + company from backend
    await authStore.fetchCurrentUser();
    await companyStore.fetchCompany(activeCompanyId.value);

    // Only this toast will show
    toast("Profile settings updated successfully");
  } catch (error) {
    console.error("Error updating profile settings:", error);
    const msg =
      error?.response?.data?.message ||
      "Failed to update profile settings. Please try again.";
    toast(msg, "error");
  } finally {
    saving.value = false;
  }
}

// ----------------------- INIT -----------------------
onMounted(async () => {
  // hydrate user form from authStore
  populateUserFromStore();

  // ensure active company details loaded
  if (activeCompanyId.value && !activeCompany.value) {
    await companyStore.fetchCompany(activeCompanyId.value);
  } else if (activeCompany.value) {
    populateCompanyForm(activeCompany.value);
  }
});

// react to authStore user changes
watch(
  () => currentUser.value,
  () => populateUserFromStore(),
  { deep: true }
);
</script>

<style scoped>
.dq-signatory-preview-sheet {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #fafbfc 100%);
}

.dq-signatory-logo {
  width: 54px;
  height: 54px;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 6px;
}

.dq-signatory-logo-fallback {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #111827;
  color: #fff;
  font-weight: 700;
}

.dq-signatory-signblock {
  min-width: 220px;
}

.dq-signatory-image {
  max-height: 56px;
  max-width: 220px;
  object-fit: contain;
}

.dq-signatory-line {
  width: 180px;
  height: 48px;
  margin-left: auto;
  border-bottom: 1px solid #cfd4dc;
}

.dq-signatory-footer {
  border-top: 1px dashed #d6dbe3;
}
</style>


